export const EXSBINVOICE_SHOW_RESET = 'EXSBINVOICE_SHOW_RESET'
export const EXSBINVOICE_SHOW_SET_ERROR = 'EXSBINVOICE_SHOW_SET_ERROR'
export const EXSBINVOICE_SHOW_SET_RETRIEVED = 'EXSBINVOICE_SHOW_SET_RETRIEVED'
export const EXSBINVOICE_SHOW_TOGGLE_LOADING = 'EXSBINVOICE_SHOW_TOGGLE_LOADING'
